/**
 * Travel Analytics Routes
 *
 * Route structure for the travel search analytics module
 */
export const TravelAnalyticsRoutes = {
  // Main analytics pages
  INDEX: "/analytics",
  OVERVIEW: "/analytics/overview",

  // Product-specific analytics
  FLIGHTS: "/analytics/flights",
  FLIGHT_ROUTE: "/analytics/flights/route/:origin/:destination",
  HOTELS: "/analytics/hotels",
  HOTEL_DESTINATION: "/analytics/hotels/destination/:destinationCode",
  CARS: "/analytics/cars",
  CAR_LOCATION: "/analytics/cars/location/:locationCode",

  // Operational analytics
  PERFORMANCE: "/analytics/performance",
  QUALITY: "/analytics/quality",

  // Business analytics
  FUNNEL: "/analytics/funnel",
  GEOGRAPHIC: "/analytics/geographic",
  PROVIDERS: "/analytics/providers",
  PROVIDER_DETAIL: "/analytics/providers/:providerId",

  // Search explorer
  SEARCHES: "/analytics/searches",
  SEARCH_DETAIL: "/analytics/searches/:searchId",

  // Reports
  SAVED_REPORTS: "/analytics/reports",
} as const;

/**
 * Helper to build dynamic route paths
 */
export const buildAnalyticsRoute = {
  flightRoute: (origin: string, destination: string) =>
    TravelAnalyticsRoutes.FLIGHT_ROUTE.replace(":origin", origin).replace(
      ":destination",
      destination
    ),

  hotelDestination: (destinationCode: string) =>
    TravelAnalyticsRoutes.HOTEL_DESTINATION.replace(":destinationCode", destinationCode),

  carLocation: (locationCode: string) =>
    TravelAnalyticsRoutes.CAR_LOCATION.replace(":locationCode", locationCode),

  providerDetail: (providerId: string) =>
    TravelAnalyticsRoutes.PROVIDER_DETAIL.replace(":providerId", providerId),

  searchDetail: (searchId: string) =>
    TravelAnalyticsRoutes.SEARCH_DETAIL.replace(":searchId", searchId),
};
